import { Box, Button } from '@mui/material';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useEmployeeContext } from '../../../Contexts/Providers/EmployeeLayoutProvider';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useMobileApi } from '../../../Api/Mobile/useMobileApi';
import { InsertLogRecordRequest, InsertRecordRequest, MobileRecordsVovClient } from '../../../ApiOld/Api/ApiServerVov';
import AfterActionScreen from '../Shared/AfterActionScreen';
import PeopleIcon from '@mui/icons-material/People';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { HomeRepairServiceOutlined, PanoramaSharp } from '@mui/icons-material';
import LoadingIndicator from '../Shared/LoadingIndicator';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import BuildingsList from '../Shared/BuildingsList';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import MobileCamera from '../Shared/MobileCamera';
import { MobilePhotoDTO } from '../Photos/MobilePhotosScreen';
import delay from '../../Shared/Functions/Delay';

export interface GeolocationDTO {
    accuracy: number;
    latitude: number;
    longitude: number;
}

export default function MobileMainActivity() {
    const param = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { setModuleButton, setPhotoTemp, photoTemp, setMenuHidden, employeeInfo, logout, diagnosticAlerts, deviceModel, deviceId, versionWithBuild } = useEmployeeContext();
    const { authorizedMobileEmployeeApi } = useMobileApi(MobileRecordsVovClient);

    const [buildingId, setBuildingId] = useState<number | undefined>(undefined);
    const [location, setLocation] = useState<GeolocationDTO | null>(null);
    const [location2, setLocation2] = useState<GeolocationDTO | null>(null);
    useEffect(() => {
        if (param.buildingId !== undefined && param.buildingId !== null) {
            if (Number(param.buildingId) !== buildingId) {
                setBuildingId(parseInt(param.buildingId));
            }
        }
    }, [param.buildingId, buildingId]);

    useEffect(() => {
        if (location2 === null) {
            if (location !== null) {
                setLocation2(location);
            } else {
                setLocation2(null);
            }

        }
        else if (location2 !== null && location === null) {
            setLocation2(null);
        }
        else if (location2 !== null && location !== null) {
            if (location2.latitude !== location.latitude || location2.longitude !== location.longitude || location2.accuracy !== location.accuracy) {
                setLocation2(location);
            }
            // setLocation2(location);
        }
    }, [location2, location]);
    const [actionDone, setActionDone] = useState<boolean>(false);
    const [actionTime, setActionTime] = useState<string>('');
    const [photoTemp2, setPhotoTemp2] = useState<string>('');
    useEffect(() => {
        if (photoTemp !== undefined && photoTemp !== null) {
            if (photoTemp2 !== photoTemp) {
                setPhotoTemp2(photoTemp);
            }
        }
    }, [photoTemp2, photoTemp]);
    const [loaded, setLoaded] = useState(true);
    const [showCamera, setShowCamera] = useState(false);
    const [type, setType] = useState<string>('');
    useEffect(() => {
        if (param.type !== undefined && param.type !== null) {
            if (param.type !== type) {
                setType(param.type);
            }
        }
    }, [param.type, type]);
    // const type = param.type; //Next Activity!!!
    const insertOnlyOnce = useRef(false);
    const insertRecord =
        useCallback(
            async (parameterPhoto?: string) => {
                let accur = location2?.accuracy ? location2?.accuracy.toString() : 'accuracy missing';
                authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                    action: 'inserting record' + buildingId + ' ' + location2?.latitude + ' ' + location2?.longitude + ' ' + accur + ' ' + type,
                    deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                }));
                try {
                    if (location2 !== null && buildingId !== undefined) {
                        // if (insertOnlyOnce.current)
                        //     return;
                        // insertOnlyOnce.current = true;
                        authorizedMobileEmployeeApi.insertRecord(new InsertRecordRequest({
                            accuracy: location2?.accuracy ? location2?.accuracy.toString() : '0.00',
                            buildingId: buildingId ?? 0,
                            gpsX: location2?.latitude ?? 0.00,
                            gpsY: location2?.longitude ?? 0.00,
                            type: type,
                            customType: '',
                            image: parameterPhoto ?? photoTemp2 ?? '',
                            deviceId: deviceId,
                            deviceModel: deviceModel,
                        })).then((res) => {
                            // insertOnlyOnce.current = false;
                            setLoaded(true);
                            // setPhotoTemp && setPhotoTemp('');
                            if (res.ok) {
                                setActionDone(true);
                                setActionTime(new Date().toTimeString().slice(0, 5));
                            } else if (res.message && !res.message.includes('adm_err_msg_cannot_insert_record_of_same_datetime')) {
                                enqueueSnackbar(res.message, { variant: 'error' });
                            }
                        }).catch((err) => {
                            // insertOnlyOnce.current = false;
                            authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                                action: 'inserting record\'s catch' + err,
                                deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                            }));
                            // if (diagnosticAlerts)
                            enqueueSnackbar("Error inserting record " + err, { variant: 'error' });
                            delay(800).then(() => {
                                navigate('../activities/error');
                            });
                        });
                    }
                    else {
                        if (diagnosticAlerts)
                            enqueueSnackbar('Calling insert record without data' + location2 !== null, { variant: 'error' });

                    }
                }
                catch (e) {
                    // insertOnlyOnce.current = false;
                    authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                        action: 'inserting record failed with exception' + e,
                        deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                    }));
                    delay(800).then(() => {
                        navigate('../activities/error');
                    });
                }
            }
            , [location2, authorizedMobileEmployeeApi, buildingId, type, deviceModel, deviceId, versionWithBuild, photoTemp2, setPhotoTemp, enqueueSnackbar, navigate, diagnosticAlerts, setActionDone]);

    window.requestLocationReact = () => {
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'falbacking to request location on web',
            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));
        if (diagnosticAlerts) enqueueSnackbar('Requesting location', { variant: 'info' });
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        accuracy: position.coords.accuracy,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                    authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                        action: 'falbacking to request location on web succ',
                        deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                    }));
                },
                (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        setLoaded(true);
                        enqueueSnackbar(t('YouNeedToAllowAccessToYourLocationToContinue'), { variant: 'error' });
                    }
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 60000
                }
            );
        }
    }

    useEffect(() => {
        setLoaded(false);
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'starting get location',
            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));
        if (diagnosticAlerts) enqueueSnackbar('Requesting location', { variant: 'info' });
        //@ts-ignore
        if (window.ReactNativeWebView)
            //@ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'get-location' }));
        else {
            window.requestLocationReact();
        }
    }, [diagnosticAlerts, enqueueSnackbar, t, authorizedMobileEmployeeApi, type, deviceModel, deviceId, versionWithBuild]);

    useEffect(() => {
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'useEffect triggered with: location=' + (location2 !== null && location2 !== undefined) +
                ', buildingId=' + buildingId +
                ', type=' + type +
                ', takeLoginPhoto=' + employeeInfo?.takeLoginPhoto

            ,

            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));

        if (location2 && buildingId && (type !== '1' || (type === '1' && employeeInfo?.takeLoginPhoto === false))) {
            authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                action: 'Conditions met - calling insertRecord()',
                deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
            }));
            setLoaded(false);
            // if (!insertOnlyOnce.current) {

            //     insertOnlyOnce.current = true;
            if (employeeInfo?.takeLoginPhoto && photoTemp2 !== '')
                insertRecord();
            else if (!employeeInfo?.takeLoginPhoto)
                insertRecord();
            //     .then(() => {
            //         delay(4000).then(() => {
            //             setLoaded(true);
            //             setActionDone(true);
            //             setActionTime(new Date().toTimeString().slice(0, 5));
            //             insertOnlyOnce.current = false;
            //         });
            //     });
            // }
            // Call insertRecord in the next tick to avoid React batching issues
            // setTimeout(() => insertRecord(), 0);
        } else if (location2 && !photoTemp2) {
            setLoaded(true);
            authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                action: 'Setting loaded=true, insertRecord NOT called',
                deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
            }));
        } else {
            authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                action: 'No action taken in useEffect',
                deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
            }));
        }
    }, [insertRecord, location2, buildingId, photoTemp2, employeeInfo?.takeLoginPhoto, type, authorizedMobileEmployeeApi, deviceModel, deviceId, versionWithBuild]);


    // useEffect(() => {
    //     if (actionDone) {
    //         setMenuHidden(true);
    //     }
    // }, [actionDone, setMenuHidden]);

    const handleCameraConfirm = useCallback((photo: MobilePhotoDTO[]) => {
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'Camera confirmed with photo',
            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));
        setShowCamera(false);
        console.log("SetPhotoTemp", photo[0].image);
        setPhotoTemp(photo[0].image);
        setLoaded(false);
        // Use timeout to ensure state updates
        // setTimeout(() => {
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'About to call insertRecord from camera confirm',
            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));
        insertRecord(photo[0].image);
        // }, 10);
    }, [authorizedMobileEmployeeApi, deviceModel, deviceId, versionWithBuild, setPhotoTemp, insertRecord]);

    window.sendLocation = (latitude: number, longitude: number, accuracy: number) => {
        authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
            action: 'get location from native succ',
            deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
        }));
        if (diagnosticAlerts)
            enqueueSnackbar('Accuracy: ' + accuracy + ', Latitude: ' + latitude + ', Longitude: ' + longitude, { variant: 'info' });
        setLocation({
            accuracy: accuracy,
            latitude: latitude,
            longitude: longitude,
        });
    };

    if (!loaded) {
        return <LoadingIndicator />;
    } else if (actionDone) {
        return <AfterActionScreen
            title={type === '4' ? 'Goodbye!' : type === '3' ? 'DontForgetToTurnOnTheAttendanceAtTheNewConstruction!' : 'WelcomeToWork!'}
            message={(type === '1' ? 'ArrivalAt' : 'DepartureAt') + ' ' + actionTime}
            action1Text='SwitchEmployee'
            action1Icon={<PeopleIcon />}
            action2Text={'Continue'}
            action2Icon={<ArrowForwardIosIcon />}
            onAction1Click={() => {
                navigate('../activities');
                logout();
            }}
            onAction2Click={() => {
                navigate('../activities');
                setModuleButton && setModuleButton(null);
            }}
            icon={type === '4' ? <HomeOutlinedIcon /> : type === '3' ? <SwapHorizOutlinedIcon /> : <HomeRepairServiceOutlined />}
        />
    }

    return (
        <Box>
            {type === '1' && (
                <Box>
                    {showCamera ?
                        <MobileCamera allowUpload={false} allowMultiple={false} defaultCameraType='user' onBackButtonClicked={() => { setShowCamera(false); setLoaded(false) }} onConfirm={handleCameraConfirm} />
                        :
                        <BuildingsList onBuildingClick={(e) => {
                            authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                                action: 'Building clicked: ' + e?.buildingId + ', takeLoginPhoto=' + employeeInfo?.takeLoginPhoto,
                                deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                            }));
                            setBuildingId(e?.buildingId);
                            if (employeeInfo?.takeLoginPhoto) {
                                setShowCamera(true);
                            } else {
                                authorizedMobileEmployeeApi.insertLog(new InsertLogRecordRequest({
                                    action: 'About to call insertRecord from BuildingsList click',
                                    deviceInfo: deviceModel + ' ' + deviceId + ' ' + versionWithBuild,
                                }));
                                // Use a timeout to ensure state updates complete
                                setTimeout(() => insertRecord(), 0);
                            }
                        }} />}
                </Box>
            )}
        </Box>
    );
}